import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { getInfoHotel, groupInColumns, coverHotelsInfo, amenitiesHotelInfo, checksTimesHotel, requirementsHotel } from './infoProductBuilder';
@Component({
  selector: 'usb-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss']
})
export class InformationComponent implements OnInit, OnChanges {

  @Input() productInfo: any[] = [];
  @Input() product: any;
  @Input() categoryId: number;
  @Input() clientSetting: any;
  @Input() subCategoryId: any;
  @Input() currencies: any;
  @Input() currencyAgency: any;
  @Input() coordinatesArr: any[] = [];
  @Input() openInfoDescription: boolean = false;
  @Input() payload: any[] = [];

  @Output() goPhotos = new EventEmitter<any>();
  @Output() openImage = new EventEmitter<number>();
  @Output() openVideo = new EventEmitter<number>();
  @Output() selectMedia = new EventEmitter<number>();
  // HOTEL

  infoHotel: any[] = [];
  columnsInfoHotel: any[][] = [];
  coverHotels:any[] =[];
  amenitiesBoolean:boolean = true;
  howToGetBoolean:boolean = true;
  atracttionsBoolean:boolean = true;
  frequentsQBoolean:boolean = true;
  amenitiesHotelInfo = [];
  arrHowToGet:any[] = [];
  starRate:boolean = true;
  hotelDescription: string = '';
  checkTimes: any[] = [];
  arrRequirements: any[] | string = [];
  arrRequirementsCovid: any[] | string = [];
  arrRequirementsOther: any[] | string = [];
  arrFacilitiesAndService: any[] = [];
  otherService: any[] | string = [];
  arrOthersTax: any[] | string = [];
  arrServicesExtras: any[] = [];
  rate: any;

  revealAtracttions: boolean = false;


  //TOUR - EXPERIENCIA
  routeVisible: boolean = false;
  descriptionComplete: boolean = false;
  stopsRoute: any[] = [];
  selectedRouteIndex: number = -1;
  selectedStop: any = null;
  coordinatesSelected: any;

     colors = [
            '#ff4d4d',  // Rojo intenso (1 - Muy malo)
            '#ff8c66',  // Rojo-naranja (2 - Malo)
            '#ffcc00',  // Amarillo (3 - Regular)
            '#66cc66',  // Verde claro (4 - Bueno)
            '#00b359'   // Verde esmeralda (5 - Excelente)
          ];

  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {

if(this.categoryId === 6 || this.categoryId === 9) {
  if(changes['openInfoDescription']['currentValue'] !== changes['openInfoDescription']['previousValue']) {
      if(changes['openInfoDescription']['currentValue']) {
        this.moreDescription();
      }
    }
}

  }

  ngOnInit(): void {
    this.getInfoPerCategory();
  }

  getInfoPerCategory(): void {
    switch (this.categoryId) {
      case 1:
          this.hotelDescription = this.product.description;
          this.infoHotel = getInfoHotel(this.product);
          this.columnsInfoHotel = groupInColumns(this.infoHotel, 2);
          this.coverHotels = coverHotelsInfo(this.product.additionalInfo.images.filter((images:any) => images.is_cover == 1)) ?? [];
          this.amenitiesHotelInfo = amenitiesHotelInfo(this.product?.additionalInfo?.amenities) && amenitiesHotelInfo(this.product?.additionalInfo?.amenities).length > 0 ? amenitiesHotelInfo(this.product?.additionalInfo?.amenities) : [];
          this.checkTimes = checksTimesHotel(this.product?.additionalInfo?.TimeInformation);
          this.arrRequirements = requirementsHotel(this.product?.additionalInfo, 'checkIn');
          this.arrRequirementsCovid = requirementsHotel(this.product?.additionalInfo, 'covid');
          this.arrRequirementsOther = requirementsHotel(this.product?.additionalInfo, 'others');
          this.otherService = requirementsHotel(this.product?.additionalInfo, 'servicesExtras');
          this.arrOthersTax = requirementsHotel(this.product?.additionalInfo, 'taxes');
          this.getObservations();
          this.servicesExtras();
          this.getStarsHotels();
      break;
      case 8:

    }
  }

  // HOTEL INFO


    booleanGenerals():void{

    if(this.amenitiesHotelInfo.length == 0){
      this.amenitiesBoolean = false;
    }

    if(this.arrHowToGet.length == 0){
      this.howToGetBoolean = false;
    }

    if(this.product.additionalInfo.atracttions.length == 0){
      this.atracttionsBoolean = false;
    }

    if(!this.product.additionalInfo.frequentquestions){
      this.frequentsQBoolean = false;
    }

    if(this.product.additionalInfo.starRating === '0' || this.product.additionalInfo.starRating === null){
      this.starRate = false;
    }
  }


    getObservations() {
    if(this.product.additionalInfo.amenities.length > 0) {


    this.product.additionalInfo.amenities.forEach((e:any) => {

      if (e.ame_subtype === 'Accesabilidad') {
        const nameObservation = 'Accesabilidad';

        // Añadir nameObservation solo si no está presente en facility
        const existingItem = this.arrFacilitiesAndService.find(item => item.facility === nameObservation);

        if (!existingItem) {
          this.arrFacilitiesAndService.push({ facility: nameObservation, services: [] });
        }
        // Añadir todos los elementos de e.name al array services
        const arrObservation = this.arrFacilitiesAndService.find(c => c.facility === nameObservation);
        arrObservation.services.push(e.name);
      }
      if(e.ame_subtype === 'Comida') {
        const nameObservation = 'Comida';
        // Añadir nameObservation solo si no está presente en facility
        const existingItem = this.arrFacilitiesAndService.find(item => item.facility === nameObservation);

        if (!existingItem) {
          this.arrFacilitiesAndService.push({ facility: nameObservation, services: [] });
        }
         // Añadir todos los elementos de e.name al array services
         const arrObservation = this.arrFacilitiesAndService.find(c => c.facility === nameObservation);
         arrObservation.services.push(e.name);
      }
    });
    }
  }

  /**
 * Función servicesExtras: Extrae y transforma la información de servicios adicionales de un hotel.
 *
 * @description Esta función toma la información de servicios extras de un hotel y la transforma en un array de objetos con propiedades 'name' y 'value'.
 *               Luego, elimina los primeros dos elementos de dicho array.
 *               Finalmente, imprime el array resultante en la consola.
 *
 * @memberof NombreDelComponenteOClase
 * @method servicesExtras
 * @returns {void} No devuelve nada, solo imprime el resultado en la consola.
 */
servicesExtras(): void {
      // Objeto de mapeo para traducción de nombres de servicios
    const servicesTraductor = {
      accept_babies: 'aceptan bebés',
      baby_price_has_cost: 'tienen costo extra los bebes',
      accept_children: 'aceptan niños/as',
      children_price_has_cost: 'tienen costo extra los/as niños/as',
      baby_has_extra_bed: 'el bebé tiene cama extra',
      extra_bed_baby_has_cost: 'tiene costo extra la cama del bebé',
      accept_pets: 'aceptan mascotas',
      cleaning_service: 'servicio de limpieza',
      reservation_fee: 'cuota de reserva',
      city_tax: 'impuesto municipal',
      city_tax_has_cost: 'tiene costo el impuesto municipal',
      iva_tax: 'impuesto iva'
    };

  // Verifica si hay información de servicios extras en el hotel
  if(this.product.additionalInfo.services_extra){ //validación temporal porque services_extra no esta en la respuesta.
    if (this.product.additionalInfo.services_extra.length > 0) {
      // Transforma la información en un array de objetos con propiedades 'name' y 'value'
      const keyValueObjectsArray = this.product.additionalInfo.services_extra.reduce((accumulator: any[], currentObject: any) => {
        // Mapea las entradas del objeto a un array de objetos con propiedades 'name' y 'value'
        const pairs = Object.entries(currentObject).map(([name, value]) => ({ name: servicesTraductor[name] || name, value }));
        // Concatena los arrays de pares 'name'-'value' al acumulador
        return accumulator.concat(pairs);
      }, []).slice(2); // Elimina los primeros dos elementos del array resultante

      // Imprime el array resultante en la consola
      this.arrServicesExtras = keyValueObjectsArray;
    }
  }

}

  /**
   * Este metedo obtiene la cantidad de estrellas,
   * obtenemos solamente la parte que nos interesa del string y la pasamos a un tipo number.
   */
  getStarsHotels():void{
    const rateStar = this.product.additionalInfo.starRating;
    if(rateStar != null){
      const numberRate = rateStar?.substring(0,1);
      this.rate = Number(numberRate);
    }
  }


  // TOUR INFO

  moreDescription(): void {
    this.descriptionComplete = !this.descriptionComplete;
  }

periodsActivities(options: any): string {

      switch (this.categoryId) {
        case 6:
           return this.getPeriodsArr(options);
        case 9:
          //  const languages = this.getLanguageArray(options);
          //  return languages.join(', ');
          break;
        default:
          break;
      }
  }
/**
 * Procesa y formatea los periodos del día basados en las sesiones disponibles,
 * eliminando duplicados y ordenándolos cronológicamente
 * @param options - Array de objetos con información de tours/actividades
 * @returns String con periodos únicos ordenados separados por comas
 */
getPeriodsArr(options: any): string {
  if (!options || !Array.isArray(options)) {
    return '';
  }

  const periodsSet = new Set<string>();

  options.forEach((option: any) => {
    if (option.sessions) {
      const sessions = Array.isArray(option.sessions)
        ? option.sessions
        : [option.sessions];

      sessions.forEach((session: string) => {
        if (session && typeof session === 'string') {
          const period = this.getTimePeriod(session);
          if (period) {
            periodsSet.add(period);
          }
        }
      });
    }
  });

  // Ordenar los periodos: mañana, tarde, noche
  const periodOrder: { [key: string]: number } = {
    'mañana': 1,
    'tarde': 2,
    'noche': 3
  };

  const periodsArray = Array.from(periodsSet).sort((a: string, b: string) =>
    periodOrder[a] - periodOrder[b]
  );

  return periodsArray.join(`${periodsArray.length > 1 ? ' y la ' : ' y '}`);
}

/**
 * Determina el periodo del día (mañana, tarde, noche) basado en la hora
 * @param timeString - Hora en formato "HH:MM" (ej: "14:30")
 * @returns String con el periodo del día correspondiente
 */
getTimePeriod(timeString: string): string {
  try {
    const [hours, minutes] = timeString.split(':').map((part: string) => Number(part));

    if (isNaN(hours) || isNaN(minutes)) {
      return 'mañana';
    }

    if (hours < 12) {
      return 'mañana';
    } else if (hours < 19) {
      return 'tarde';
    } else {
      return 'noche';
    }
  } catch (error) {
    return 'mañana';
  }
}


getDurations(options: any): string {
     switch (this.categoryId) {
        case 6:
           return this.getDurationsArr(options);
        case 9:
          //  const languages = this.getLanguageArray(options);
          //  return languages.join(', ');
          break;
        default:
          return '';
    }
}

/**
 * Procesa y formatea las duraciones disponibles en las opciones,
 * eliminando duplicados y retornando un string formateado
 * @param options - Array de objetos con información de tours/actividades
 * @returns String con duraciones únicas formateadas separadas por comas
 */
getDurationsArr(options: any): string {
  if (!options || !Array.isArray(options)) {
    return '';
  }

  const durationsSet = new Set<string>();

  options.forEach((option: any) => {
    if (option.duration) {
      const durations = Array.isArray(option.duration)
        ? option.duration
        : [option.duration];

      durations.forEach((duration: string) => {
        if (duration && typeof duration === 'string') {
          const formattedDuration = this.builderDuration(duration);
          if (formattedDuration) {
            durationsSet.add(formattedDuration);
          }
        }
      });
    }
  });

  const durationsArray = Array.from(durationsSet);
  return durationsArray.join(', ');
}

/**
 * Convierte un string de duración en formato técnico a formato legible
 * @param timeString - Duración en formato "valor-tipo" (ej: "1-DAYS")
 * @returns String formateado para mostrar al usuario
 */
builderDuration(timeString: string): string {
  try {
    const parts = timeString.split('-').map((part: string) => part.trim());

    if (parts.length !== 2) {
      return 'N/A';
    }

    const value = parseInt(parts[0], 10);
    const type = parts[1].toUpperCase();

    if (isNaN(value)) {
      return 'N/A';
    }

    if (type === 'DAYS') {
      if (value === 1) {
        return '1 día';
      } else {
        return `${value} días`;
      }
    } else if (type === 'HOURS') {
      return `${value} minutos`;
    } else {
      return `${value} ${type}`;
    }
  } catch (error) {
    return 'N/A';
  }
}

/**
 * Obtiene los idiomas disponibles formateados como string separado por comas
 * @param options - Array de objetos con información de tours/actividades
 * @returns String con idiomas únicos separados por comas
 */
getLanguages(options: any): string {
  const languages = this.getLanguageArray(options);
  return languages.join(', ');
}

/**
 * Extrae y retorna un array con los idiomas únicos disponibles en las opciones
 * @param options - Array de objetos con información de tours/actividades
 * @returns Array de strings con idiomas únicos
 */
getLanguageArray(options: any): string[] {
  if (!options || !Array.isArray(options)) {
    return [];
  }

  const languagesSet = new Set<string>();

  options.forEach((option: any) => {
    if (option.language) {
      if (Array.isArray(option.language)) {
        option.language.forEach((lang: string) => {
          languagesSet.add(lang);
        });
      } else {
        languagesSet.add(option.language);
      }
    }
  });

  return Array.from(languagesSet);
}

getGuideAmenity(amenities: any[]): string {
  if (!amenities || amenities.length === 0) {
    return '';
  }

  const matches = new Set<string>();

  amenities.forEach((amenity: any) => {
    if (amenity.description) {
      const desc = amenity.description.toLowerCase();

      const iconPatterns = [
        { pattern: /(guía|guia|guide)/, text: 'con guía' },
        { pattern: /(auriculares)/, text: 'con auriculares' },
        { pattern: /(audioguia|audioguía)/, text: 'con audioguía' }
      ];

      const matchedPattern = iconPatterns.find(item => item.pattern.test(desc));

      if (matchedPattern) {
        matches.add(matchedPattern.text);
      }
    }
  });

  const matchString = Array.from(matches).join(' y en ');
  return matchString ? `${matchString} en ` : 'en ';
}

toggleRoute(routes: any, index: number): void {
    if(this.selectedRouteIndex === index) {
      this.selectedRouteIndex = -1;
      this.stopsRoute = [];
      this.routeVisible = false;
    } else {
      this.visibleRoute(routes, index);
      this.selectedRouteIndex = index;
    }
  }

visibleRoute(routes, index): void {
  const route = routes[index];
  this.stopsRoute = route.points;
  this.getStopCircleStyles(this.stopsRoute[0]);
  this.selectStop(this.stopsRoute[0]);
  this.routeVisible = !this.routeVisible;
}

getStopCircleStyles(stop: any): any {
  const mainColor = this.clientSetting?.clients_setting_global?.color_main_1;
  const isActive = this.selectedStop?.order === stop.order;

  return {
    'border': isActive ? `2px solid ${mainColor}` : '2px solid #ececec',
    'background-color': 'transparent',
    'cursor': 'pointer',
    'transition': 'all 0.3s ease'
  };
}

    // Método para seleccionar una parada
    selectStop(stop: any): void {
      this.selectedStop = stop;

      // Emitir las coordenadas para el mapa
      this.emitStopCoordinates(stop.coordinates);
    }

      // Método para emitir coordenadas al mapa
    private emitStopCoordinates(coordinates: any): void {

      this.coordinatesSelected = coordinates;

    }

  /**
   * Devuelve true si el objeto de temporada tiene al menos una fecha `from` o `to` con valor.
   * Sirve para no renderizar la columna completa cuando ambos vienen vacíos/null/undefined.
   */
  hasSeasonDates(season: { from?: any; to?: any } | null | undefined): boolean {
    if (!season) return false;
    const from = season.from;
    const to = season.to;
    const hasFrom = from !== null && from !== undefined && from !== '';
    const hasTo = to !== null && to !== undefined && to !== '';
    return hasFrom || hasTo;
  }

  get cancellationPolicyDate(): Date | null {
    const policy = this.product?.additionalInfo?.tours?.options?.[0]?.cancellation_policy;
    return policy && policy.length > 0 ? policy[0]?.dateFrom : null;
  }

  iconsArr(): any[] {
    return [1,2,3,4,5];
  }

  /**
   * Mock media para el selector de usb-media-banner.
   * Mientras el backend no devuelva product.additionalInfo.media ni videos,
   * alimenta el switch con 1 video + 1 foto fake para previsualizar el comportamiento.
   * Cuando llegue data real, mediaItems prioriza el backend y este mock queda inerte.
   * (Mismo patrón que modal-tours.component.ts — ver comentario en su línea 2094.)
   */
  mockMedia: Array<{ type: 'image' | 'video'; src: string }> = [
    { type: 'video', src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4' },
    { type: 'image', src: 'assets/img/sin-logo.png' },
  ];

  /** Estado del selector interno del banner (default: primer item = foto). */
  activeMediaIndex: number = 1;
  activeMedia: { type: 'image' | 'video'; src: string } | null = null;

          getIconsComments(index: number): string {
            switch(index) {
              case 0:
                return '../../../../assets/icons/comments-assesment/MALO.svg';
              case 1:
                return '../../../../assets/icons/comments-assesment/REGULAR.svg';
              case 2:
                return '../../../../assets/icons/comments-assesment/BUENO.svg';
              case 3:
                return '../../../../assets/icons/comments-assesment/MUYBUENO.svg';
              case 4:
                return '../../../../assets/icons/comments-assesment/EXCELENTE.svg';
            }

          }


          openAtracttions(product: any, category: number): void {

            switch(category) {
              case 1:
                this.revealAtracttions = !this.revealAtracttions;
                break;
            }
          }

          get truncatedDescription(): string {
            const desc = this.product?.description || '';
            if (desc.length <= 300) return desc;
            return desc.substring(0, 300) + '';
          }

          get fullDescription(): string {
            return this.product?.description || 'Sin descripción';
          }

          goTabPhotos(): void {
            this.goPhotos.emit();
          }

          /**
           * Extrae el src de un item de video probando varios campos posibles.
           * Defensivo: el backend puede mandar {src}, {url}, {thumbnail} o el string directo.
           */
          private pickVideoSrc(v: any): string {
            if (!v) return '';
            if (typeof v === 'string') return v;
            return v.src ?? v.url ?? v.thumbnail ?? v.video ?? '';
          }

          /**
           * Videos para el slotter de usb-media-banner.
           * Shape esperado por el banner: Array<{src: string}>.
           */
          get videoItems(): Array<{ src: string }> {
            return (this.product?.additionalInfo?.videos || [])
              .map((v: any) => ({ src: this.pickVideoSrc(v) }))
              .filter((v: { src: string }) => !!v.src);
          }

          /**
           * Media mixto para el selector flotante de usb-media-banner.
           * Shape esperado por el banner: Array<{type: 'image' | 'video'; src: string}>.
           *
           * IMPORTANTE: NO debe incluir toda la galería de imágenes.
           * El banner renderiza UN botón por cada item en este array (ver usb-media-banner.component.html).
           * Si metés 8 imágenes acá, se ven 8 íconos cámara en el selector.
           *
           * Prioridad de fuente:
           *   1) product.additionalInfo.videos + .images → se filtra por videos reales
           *   2) product.additionalInfo.media (lo que el backend marque como selector del tour)
           *   3) mockMedia (1 video + 1 foto fake) para previsualizar mientras no llega backend
           */
          get mediaItems(): Array<{ type: 'image' | 'video'; src: string }> {
            const backendVideos = this.videoItems;
            if (backendVideos.length > 0) {
              const representativeImage = this.product?.additionalInfo?.images?.find((img: any) => img?.is_cover)?.thumbnail
                ?? this.product?.additionalInfo?.images?.[0]?.thumbnail;
              const items: Array<{ type: 'image' | 'video'; src: string }> = [];
              if (representativeImage) {
                items.push({ type: 'image', src: representativeImage });
              }
              backendVideos.forEach((v) => items.push({ type: 'video', src: v.src }));
              return items;
            }

            const backendMedia = this.product?.additionalInfo?.media;
            if (Array.isArray(backendMedia) && backendMedia.length > 0) {
              return backendMedia
                .map((m: any) => ({
                  type: (m.type === 'video' ? 'video' : 'image') as 'image' | 'video',
                  src: this.pickVideoSrc(m),
                }))
                .filter((m: { src: string }) => !!m.src);
            }

            return this.mockMedia;
          }

          /**
           * Handler del click en un botón del selector.
           * Mantiene el estado interno en sync y reemite al padre para que dispare el lightbox.
           */
          onSelectMedia(index: number): void {
            this.activeMediaIndex = index;
            this.activeMedia = this.mediaItems[index] ?? null;
            this.selectMedia.emit(index);
          }

}
